import SummaryTable from "./SummaryTable";
export default SummaryTable;